import { useEffect, useRef } from "react"
import { useLocation } from 'react-router-dom';

// //Import Scrollbar
import SimpleBar from "simplebar-react"


// MetisMenu
import MetisMenu from "metismenujs"
import { Link } from "react-router-dom"

import { route, routes } from "~/helpers/routeHelper"
import { Badge } from "reactstrap";

const SidebarContent = () => {
  const location = useLocation();

  const ref = useRef(null);

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = location.pathname

    const initMenu = () => {
      // Clear all active classes first
      const ul = document.getElementById("side-menu")
      if (!ul) return;

      const allItems = ul.getElementsByTagName("a")
      const allLi = ul.getElementsByTagName("li")
      const allUl = ul.getElementsByTagName("ul")

      // Remove active classes from all links
      for (let i = 0; i < allItems.length; ++i) {
        allItems[i].classList.remove("active", "mm-active")
      }

      // Remove active classes from all li elements
      for (let i = 0; i < allLi.length; ++i) {
        allLi[i].classList.remove("mm-active")
      }

      // Remove show classes from all ul elements
      for (let i = 0; i < allUl.length; ++i) {
        allUl[i].classList.remove("mm-show")
      }

      // Initialize MetisMenu
      new MetisMenu("#side-menu")

      let matchingMenuItem: HTMLAnchorElement | null = null
      const items = ul.getElementsByTagName("a")

      for (let i = 0; i < items.length; ++i) {
        const item = items[i] as HTMLAnchorElement;
        let activeFor = item.getAttribute('data-active-for');
        let isActiveFor = false;
        if (activeFor) {
          const activeForArray = activeFor.split('~');
          isActiveFor = activeForArray.some((pattern: string) => {
            const re = new RegExp(pattern);
            return re.test(pathName);
          });
        }
        // Get the actual pathname from the Link component's href
        const linkPath = item.getAttribute('href') || item.pathname;
        if (pathName === linkPath || isActiveFor) {
          matchingMenuItem = item
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [location.pathname])

  useEffect(() => {
    if (ref.current) {
      (ref.current as any).recalculate()
    }
  }, [location.pathname])

  function scrollElement(item: HTMLAnchorElement | null) {
    if (item && ref.current) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        const scrollElement = (ref.current as any).getScrollElement();
        if (scrollElement) {
          scrollElement.scrollTop = currentPosition - 300
        }
      }
    }
  }

  function activateParentDropdown(item: HTMLAnchorElement) {
    if (item.classList.contains('active')) {
      return false;
    }
    item.classList.add("active")
    const parent = item.parentElement
    if (!parent) {
      scrollElement(item);
      return false;
    }

    const parent2El = parent.childNodes[1] as HTMLElement | undefined
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    parent.classList.add("mm-active")
    const parent2 = parent.parentElement

    if (parent2) {
      parent2.classList.add("mm-show") // ul tag

      const parent3 = parent2.parentElement // li tag

      if (parent3) {
        parent3.classList.add("mm-active") // li
        const firstChild = parent3.childNodes[0] as HTMLElement | undefined
        if (firstChild) {
          firstChild.classList.add("mm-active") //a
        }
        const parent4 = parent3.parentElement // ul
        if (parent4) {
          parent4.classList.add("mm-show") // ul
          const parent5 = parent4.parentElement
          if (parent5) {
            parent5.classList.add("mm-show") // li
            const firstChild5 = parent5.childNodes[0] as HTMLElement | undefined
            if (firstChild5) {
              firstChild5.classList.add("mm-active") // a tag
            }
          }
        }
      }
    }
    scrollElement(item);
    return false
  }

  return (
    <>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu" className="h-100">
          <ul className="metismenu list-unstyled d-flex flex-column h-100" id="side-menu">
            <li className="menu-title">Menu</li>

            <li>
              <Link to={route(routes.home)} data-active-for="^\/dashboard($|\/(.*)+)">
                <i className="bx bx-home-circle"></i>
                <span>Dashboard</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.list_notary_bids)} data-active-for="^\/notary-bid($|\/(.*)+)">
                <i className="bx bx-user-pin"></i>
                <span>My Leads</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.list_orders)} data-active-for="^\/order($|\/(.*)+)">
                <i className="mdi mdi-shopping"></i>
                <span>My Orders</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.view_profile)} data-active-for="^\/profile($|\/(.*)+)">
                <i className="bx bx-user"></i>
                <span>Notary Profile</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.list_notary_accounting)} data-active-for="^\/notary-accounting($|\/(.*)+)">
                <i className="bx bx-calculator"></i>
                <span>Accounting</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.view_documents)} data-active-for="^\/documents($|\/(.*)+)" state={{ isRedirect: true }}>
                <i className="bx bx-file"></i>
                <span>Documents</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.list_messages)} data-active-for="^\/message($|\/(.*)+)">
                <i className="mdi mdi-message-text"></i>
                <span>Messages</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.list_help)} data-active-for="^\/help($|\/(.*)+)">
                <i className="mdi mdi-help-circle-outline"></i>
                <span>Help section</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.view_terms)} data-active-for="^\/terms($|\/(.*)+)">
                <i className="mdi mdi-account-check-outline"></i>
                <span>Service Agreement</span>
              </Link>
            </li>

            <li>
              <Link to={route(routes.view_notary_mobile_app)} data-active-for="^\/notary-mobile-app($|\/(.*)+)">
                <i className="mdi mdi-cellphone"></i>
                <span>Notary Mobile App</span>
                <Badge className="badge-sm rounded-pill bg-danger ms-2">New</Badge>
              </Link>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </>
  );
};

export default SidebarContent;
